import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FiImage } from 'react-icons/fi';

/** A supplier image that falls back to a neutral tile when it is missing or fails to load. */
function PackageImage({ src, alt, className, loading }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return (
      <span className={`pkg-img pkg-img--fallback ${className}`} aria-hidden>
        <FiImage size={26} />
      </span>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      className={`pkg-img ${className}`}
      loading={loading}
      onError={() => setFailed(true)}
    />
  );
}

PackageImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  loading: PropTypes.oneOf(['lazy', 'eager']),
};

PackageImage.defaultProps = {
  src: '',
  alt: '',
  className: '',
  loading: 'lazy',
};

export default PackageImage;
